module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.component_class,
    style: (_vm.tab_style)
  }, _vm._l((_vm.tab_data), function(item, i) {
    return _c('div', {
      key: i,
      class: [_vm.item_class, {
        active: _vm.value === i
      }],
      style: ([_vm.item_style, _vm.value === i ? _vm.activeStyle : {}]),
      on: {
        "click": function($event) {
          _vm.handleClick(i, item.name)
        },
        "mouseenter": function($event) {
          _vm.handleMouseEnter(i, item.name)
        }
      }
    }, [(item.icon) ? _c('Icon', {
      staticClass: "hiui-icon-prefix",
      attrs: {
        "name": item.icon
      }
    }) : _vm._e(), _vm._v("\n       " + _vm._s(item.name) + "\n       "), (item.suffix_icon) ? _c('Icon', {
      staticClass: "hiui-icon-suffix",
      attrs: {
        "name": item.suffix_icon
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ad2a59f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tab/Tab.vue
// module id = 679
// module chunks = 0